import { render, staticRenderFns } from "./CustomerInfoSection.vue?vue&type=template&id=28deb4d2"
import script from "./CustomerInfoSection.vue?vue&type=script&lang=js"
export * from "./CustomerInfoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports